import { ApiKeyCard } from '../../user/modal/security/api-key-card/api-key-card.component';
import { BadgeCard } from '../../user/modal/security/badge-card/badge-card.component';
import { BasicAuthCard } from '../../user/modal/security/basic-auth-card/basic-auth-card.component';
import { PersonalQrCodeCard } from '../../user/modal/security/personal-qr-code-card/personal-qr-code-card.component';

interface AuthenticationTabProps {
    userId: string;
}

const AuthenticationTab = ({ userId }: AuthenticationTabProps) => {
    return (
        <div className='flex w-full gap-6'>
            <div className='grid flex-1 grid-cols-2 gap-4'>
                <BasicAuthCard
                    entity_id={String(userId)}
                    selfService
                />
                <BadgeCard entity_id={String(userId)} />
                <ApiKeyCard
                    entity_id={String(userId)}
                    selfService
                />
                <PersonalQrCodeCard entity_id={String(userId)} />
            </div>
            <div className='w-96'></div>
        </div>
    );
};

export default AuthenticationTab;
